import { createFileRoute } from '@tanstack/react-router';
import RegulationList from '@/components/features/compliance/components/regulation-list';

export const Route = createFileRoute('/_authenticated/compliance/regulations')({
  component: RegulationList,
});
